import { FC } from "react";
import { observer } from "mobx-react";
import { FullScreenLayout } from "../../components-v2/FullScreenLayout";
import { useAppBar } from "../../appBar/useAppBar";
import { Language } from "../../i18n/languages";
import { useLanguage } from "../../stores/RootStoreContext";
import { PortfolioType, usePortfolio } from "../../portfolio/portfolioDomain";

const HelpCenter: FC<{
  portfolioId?: string;
  isPortfolioPage?: boolean;
  portfolioType: PortfolioType;
}> = observer(({ portfolioId, isPortfolioPage, portfolioType }) => {
  const { portfolio } = usePortfolio({
    activeHeader: "help-center",
    portfolioId,
    portfolioType,
  });
  const appBar = useAppBar({
    isPortfolioPage,
    selectedPortfolioOption: portfolio,
    portfolioHeader: "help-center",
  });
  const lang = useLanguage();
  const adjustedLang = lang === Language.SV ? Language.NO : lang;
  return (
    <FullScreenLayout
      appBar={appBar}
      centerPanelContainerProps={{ className: "relative" }}
      centerPanel={
        <iframe
          src={`https://dcompany.no/${adjustedLang}/help-center/`}
          style={{ position: "absolute", height: "100%", width: "100%" }}
          height="100%"
          width="100%"
        />
      }
    />
  );
});
export default HelpCenter;
